import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <div className="not-found-container">
            <h1 className="not-found-heading">404</h1>
            <p className="not-found-message">This page doesn't exist.</p>
            <Link to="/" className="not-found-link">Back to Home</Link>
        </div>
    );
};

export default NotFound;
